import { useI18n } from '../../i18n'
import { Button } from '../ui/Button'
import entStyles from '../../styles/enterprise/EnterpriseOperationalUx.module.scss'
import type { ReportsView } from '../../pages/reports/reportsView'
import { buildReportsViewHref } from '../../pages/reports/reportsView'

type Props = {
  view: ReportsView
  searchParams: URLSearchParams
  onNavigate: (href: string) => void
}

const VIEWS: { id: ReportsView; labelKey: string; fallback: string }[] = [
  { id: 'overview', labelKey: 'reports.nav.overview', fallback: 'Overview' },
  { id: 'findings', labelKey: 'reports.nav.findings', fallback: 'Current Findings' },
  { id: 'assessments', labelKey: 'reports.nav.assessments', fallback: 'Scanner Assessments' },
  { id: 'uploads', labelKey: 'reports.nav.uploads', fallback: 'Uploaded Files' },
]

export default function ReportsViewNav({ view, searchParams, onNavigate }: Props) {
  const { t } = useI18n()

  return (
    <nav
      className="flex flex-wrap gap-2 mb-4"
      aria-label={t('reports.nav.aria', 'Reports workspaces')}
      data-testid="reports-view-nav"
    >
      {VIEWS.map((item) => (
        <Button
          key={item.id}
          type="button"
          size="small"
          color={view === item.id ? 'primary' : 'outline'}
          aria-current={view === item.id ? 'page' : undefined}
          onClick={() => onNavigate(buildReportsViewHref(item.id, searchParams))}
        >
          {t(item.labelKey, item.fallback)}
        </Button>
      ))}
    </nav>
  )
}
